import { createSlice } from '@reduxjs/toolkit';

const licensesSlice = createSlice({
  name: 'licenses',
  initialState: {
    licenses: [],
  },
  reducers: {
    fetchLicensesSuccess: (state, action) => {
      state.licenses = action.payload;
    },
  },
});

export const { fetchLicensesSuccess } = licensesSlice.actions;

export default licensesSlice.reducer;
